module.exports = __webpack_public_path__ + "img/logo_28.b37be900.png";